import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import style from './styles/style.module.css';

import checkBox from 'appSrc/assets/img/recommended/CheckBox.svg';
import circle from 'appSrc/assets/img/recommended/Circle.svg';

class CheckCircle extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            checked: false,
        };
    }
    render() {
        const { checked } = this.state;
        const { label } = this.props;
        return (
            <div style={ this.props.style }
            className={ `${ style.checkCircle } ${ this.props.className }` }>
                <div className={ style.box }>
                    { checked ?
                        <img src={checkBox} /> : <img src={circle} />
                    }
                </div>
                { label &&
                    <div className={ style.label }>{ label }</div>
                }
            </div>
        );
    }
}
CheckCircle.propTypes = {
    label: PropTypes.string,
};

export default CheckCircle;
